import React from "react";
import { Award } from "lucide-react";

const medal = {
  "Platinum Certified": { base: "#2B3A55", ring: "#E7ECF5", text: "Platinum" },
  "Gold Certified": { base: "#D6A84A", ring: "#FFF1C2", text: "Gold" },
  "Silver Certified": { base: "#8A94A6", ring: "#D7DCE6", text: "Silver" },
  "Bronze Certified": { base: "#B46A3C", ring: "#E3A07A", text: "Bronze" },
  "Not Certified": { base: "#8A94A6", ring: "#E3E8F2", text: "Not Certified" },
};

export const LevelBadge = ({ level, size = 120, showLabel = true, testId }) => {
  const m = medal[level] || medal["Not Certified"];
  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <div
        className="relative flex items-center justify-center rounded-full"
        style={{
          width: size,
          height: size,
          background: `conic-gradient(${m.base}, ${m.ring}, ${m.base})`,
          padding: 6,
        }}
      >
        <div className="flex h-full w-full flex-col items-center justify-center rounded-full bg-white text-center shadow-inner" style={{ border: `2px solid ${m.base}` }}>
          <Award className="mb-1" style={{ color: m.base, width: size * 0.26, height: size * 0.26 }} />
          <span className="font-heading font-semibold text-navy-900" style={{ fontSize: size * 0.14 }}>{m.text}</span>
        </div>
      </div>
      {showLabel && <span className="mt-2 text-sm font-semibold text-navy-900">{level}</span>}
    </div>
  );
};

export default LevelBadge;
